import React, { Children, cloneElement, ReactElement } from 'react';

import { FieldListAPI, Form } from '@philips-emr/tws-components';
import { AwesomeComponent, ComponentType, Value } from '@philips-emr/tws-core';
import { ChangeEvent } from '@philips-emr/tws-core/lib/component/types';

import HpmsCustomListField from '../hpms-custom-list-field/hpms-custom-list-field';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: FieldListAPI })
export default class HpmsCustomListFieldValidatorValue extends HpmsCustomListField {

  renderRow(row: Record<string, Value>, index: number): ReactElement {
    const { children, readOnly, uuid } = this.props;

    const formProps = {
      data: row,
      disabled: true,
      editing: !readOnly,
      index,
      onChange: (event: ChangeEvent<Record<string, Value>>) => this.onChange(event, index),
      uuid,
    };

    const childProps = {
      '@repeated': true,
      identifier: index,
      onBlur: this.onBlur,
    };

    return (
      <div className="c-field-list__row" key={index} >
        <Form {...formProps}>
          {Children.map(children, child => {
            let localValidators: Record<string, Function> | undefined;

            // @ts-ignore
            const { props: originalChildProps } = child;

            if (originalChildProps.entry === 'value') {
              localValidators = {
                isSumIslowerOrEqualTheValue: (fieldValue: string): Array<Record<string, any>> => {
                  const { vlOperationalCost, vlDoctor, vlFilmValue } = row;

                  const vlTotal = Number(vlOperationalCost ?? 0) +
                    Number(vlDoctor ?? 0) +
                    Number(vlFilmValue ?? 0);

                  const valid = Number(fieldValue ?? 0) >= vlTotal;

                  return [
                    {
                      message: !valid ? 'pa.message-total-value' : '',
                      name: 'isSumIslowerOrEqualTheValue',
                      valid,
                    },
                  ];
                },
              };
            }

            // @ts-ignore
            return cloneElement(child, { ...childProps, localValidators });
          }
          )}
        </Form>

        {this.renderRemove(index)}
      </div>
    );
  }
}
